import React, { useEffect, useState } from "react";
import profile from "../Assets/Approvalcard/driver.jpg";
import back from "../Assets/dsp/back.svg";
import file from "../Assets/dsp/file.svg";
import download from "../Assets/dsp/download.svg";
import "../Style/Component/Driverspecificpayment.css";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getWithTokenAPI, putWithTokenAPI } from "../Util/Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
const Driverspecificpayment = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const permission = auth.permission;
  const navigate = useNavigate();
  const { type, id } = useParams();
  const [specificdriver, setSpecificDriver] = useState([]);
  useEffect(() => {
    fetchapprovallist();
  }, [token]);
  const fetchapprovallist = async () => {
    try {
      const response = await getWithTokenAPI(token, `/user/profile/${id}`);
      setSpecificDriver(response?.data);
    } catch {
      console.log("Error in fetching Limit Api");
    }
  };
  const handleblock = () => {
    Swal.fire({
      title: "Block Driver?",
      text: "Sure to Block this driver",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "rgb(186, 28, 28)",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Block",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleblockdriver(); // your function
      }
    });
  };
  const handleblockdriver = async () => {
    try {
      const response = await putWithTokenAPI(token, `/user/update/${id}`, {
        blocked: !specificdriver?.blocked,
      });
      if (response?.statusCode === 200) {
        toast.success(
          `Driver ${specificdriver?.name} ${specificdriver?.blocked ? "UnBlocked" : "Blocked"} Successfully`,
        );
        fetchapprovallist();
      } else {
        toast.error(`Driver Status Update Unsuccessful`);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const giveApprove = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        is_driver_form: "Approved",
      };
      console.log("payload for approve", payload);
      const response = await putWithTokenAPI(
        token,
        `/user/update/${id}`,
        payload,
      );
      console.log("response", response);
      if (response?.statusCode == 200) {
        console.log("Approved Successfully");
        toast.success("Driver approved successfully");
        navigate(-1);
      }
    } catch (error) {
      console.error("Error in Approving:", error);
    }
  };
  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}.${month}.${year}`;
  }

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = url;
    link.target = "_self";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="driverspecificpayment">
      <div className="dsptop">
        <img src={back} onClick={() => navigate(-1)} />
        Profile
      </div>
      <div className="dspbody">
        <div className="dspbodyleft">
          <div className="dspimage">
            <img src={specificdriver?.profileimage || profile}></img>
          </div>
          <div className="dsplist">
            <span>
              <label>Name</label>
              {specificdriver?.name}
            </span>
            <span>
              <label>Phone Number</label>+91{specificdriver?.phoneNumber}
            </span>
            <span>
              <label>Address</label>
              <span className="addre">
                {specificdriver?.location1?.[0]?.currentAddress}
              </span>
            </span>
            <span>
              <label>Aadhar No</label>
              {specificdriver?.aadhaarnumber}
            </span>
          </div>
        </div>
        <div className="dspright">
          <div className="dspvdetails">
            <div className="dsplisthead">Vehicle Details</div>
            <div className="dsplist">
              <span>
                <label>Vehicle Type</label>
                {specificdriver?.driverDetails?.vehicle?.vehicleType}
              </span>
              <span>
                <label>Vehicle no</label>
                {specificdriver?.driverDetails?.vehicle?.registrationNo}
              </span>
              <span>
                <label>Vehicle Name</label>{" "}
                {specificdriver?.driverDetails?.vehicle?.vehicleModel}
              </span>
              <span>
                <label>Monthly Rent</label>
              </span>
            </div>
          </div>
          <div className="dspvdetails">
            <div className="dsplisthead">Vehicle Details</div>
            <div className="dsplist">
              {specificdriver?.driverDetails?.license?.licenseImage && (
                <span>
                  <label>License</label>
                  <div>
                    <a
                      href={
                        specificdriver?.driverDetails?.license?.licenseImage
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        src={file}
                        alt="License"
                        style={{ cursor: "pointer" }}
                      />
                    </a>
                    <img
                      src={download}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleDownload(
                          specificdriver?.driverDetails?.license?.licenseImage,
                        )
                      }
                    />
                  </div>
                </span>
              )}
              {specificdriver?.aadhaarimg && (
                <span>
                  <label>Aadhar Card</label>
                  <div>
                    <a
                      href={specificdriver?.aadhaarimg}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={file} style={{ cursor: "pointer" }} />
                    </a>
                    <img
                      src={download}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleDownload(specificdriver?.aadhaarimg)}
                    />
                  </div>
                </span>
              )}
              {specificdriver?.driverDetails?.vehicle?.insurance
                ?.insuranceDocument && (
                <span>
                  <label>Insurance</label>
                  <div>
                    <a
                      href={
                        specificdriver?.driverDetails?.vehicle?.insurance
                          ?.insuranceDocument
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={file} style={{ cursor: "pointer" }} />
                    </a>
                    <img
                      src={download}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleDownload(
                          specificdriver?.driverDetails?.vehicle?.insurance
                            ?.insuranceDocument,
                        )
                      }
                    />
                  </div>
                </span>
              )}
              {specificdriver?.driverDetails?.vehicle?.vehiclePhotos && (
                <span>
                  <label>Vehicle Photos</label>
                  <div>
                    <a
                      href={
                        specificdriver?.driverDetails?.vehicle
                          ?.vehiclePhotos?.[0]
                      }
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={file} style={{ cursor: "pointer" }} />
                    </a>
                    <img
                      src={download}
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        handleDownload(
                          specificdriver?.driverDetails?.vehicle
                            ?.vehiclePhotos?.[0],
                        )
                      }
                    />
                  </div>
                </span>
              )}
            </div>
          </div>
          {type === "approval" && permission?.approval?.update && (
            <div className="dspothers">
              {/* <button type="submit" style={{ border: "1px solid red" }}>
                Cancel
              </button> */}
              <button
                type="submit"
                style={{ backgroundColor: "var(--primary" }}
                onClick={(e) => giveApprove(e)}
              >
                Approve
              </button>
            </div>
          )}
          {type === "prices" && permission?.approval?.update && (
            <div className="dspothers">
              <span>
                <label>Verification Date</label>
                {formatDate(specificdriver?.is_driver_form_approved_date)}
              </span>
              <button
                type="submit"
                style={{
                  backgroundColor: specificdriver?.blocked
                    ? "rgb(35, 110, 35)"
                    : "",
                }}
                onClick={() => handleblock()}
              >
                {specificdriver?.blocked ? "Unblock" : "Block"}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Driverspecificpayment;
